import { render } from "./OptionEditor.vue?vue&type=template&id=1ba2b9cb&scoped=true"
import script from "./OptionEditor.vue?vue&type=script&lang=js"
export * from "./OptionEditor.vue?vue&type=script&lang=js"

import "./OptionEditor.vue?vue&type=style&index=0&id=1ba2b9cb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba2b9cb"]])

export default __exports__